import React from 'react';

import { Icon, IconTypes } from '@eika/icon';
import { ListPanel } from '@eika/link-panel';

import { useConfigLink } from '@/domain/app';

import { SitecoreCardControlProps } from '@domain/card';
import { getKredittbankenUrl } from '@utils/url-utils';

export const CreditCardPanelItemWithSitecoreLink = <T extends string>({
    hide,
    iconType,
    piwikTag,
    title,
    account,
    card,
    subtitle,
    id,
    sitecorePath,
}: SitecoreCardControlProps<T>) => {
    const configUrl = useConfigLink(sitecorePath);
    const finalUrl = getKredittbankenUrl(configUrl.url, card, account);
    if (hide) {
        return null;
    }

    return (
        <ListPanel
            data-track-id={piwikTag.dataTrackId}
            prefixContent={<Icon type={iconType} />}
            data-track-linkname={piwikTag.dataTrackLinkname}
            url={finalUrl}
            id={id || 'link-card-control'}
            backgroundColor="light"
            icon={IconTypes.PIL_HOEYRE}
            title={title}
            textTwo={subtitle}
        />
    );
};
